export default __webpack_public_path__ + "resources/icons/d331-0779.webp";